import { vl } from '../../data/atoms.vl';
import { useAtom } from 'jotai/index';
import { SellPrivatelyDialog } from './SellPrivately/SellPrivatelyDialog';
// import { EditPropertiesDialog } from './EditProperties/EditPropertiesDialog';
// import { AddPdfsDialog } from './Attachments/AddPDFs';

export function VLModals() {
  const [currentModal, setCurrentModal] = useAtom(vl.currentModalAtom);

  switch (currentModal) {
    case VL1Modals.SellPrivately:
      return <SellPrivatelyDialog opened={currentModal === VL1Modals.SellPrivately} onClose={() => setCurrentModal(null)} />;
    // case DtiModals.EditProperties:
    //   return <EditPropertiesDialog opened={currentModal === DtiModals.EditProperties} onClose={() => setCurrentModal(null)} />;
    // case DtiModals.AddPdfs:
    //   return <AddPdfsDialog opened={currentModal === DtiModals.AddPdfs} onClose={() => setCurrentModal(null)} />;
    default:
      return null;
  }
}

export enum VL1Modals {
  SellPrivately = 'SellPrivately',
  EditProperties = 'EditProperties',
  AddPdfs = 'AddPfs',
}
